import { render, staticRenderFns } from "./treasureCalendarMonth.vue?vue&type=template&id=87be1f78&"
import script from "./treasureCalendarMonth.vue?vue&type=script&lang=js&"
export * from "./treasureCalendarMonth.vue?vue&type=script&lang=js&"
import style0 from "./treasureCalendarMonth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports